import React from "react";
import Popup from "reactjs-popup";
import SpinInput from "../inputs/SpinInput";
import PropTypes from "prop-types";
import "./demander-produit-prix.css";
import { addToShoppingCart } from '../actions/shop';
import { useDispatch } from 'react-redux';

const DemanderProduitPrix = (props) => {
  const dispatch = useDispatch();

  const onChange = (i, e) => {
    if (e?.target) {
      const raw = e.target.value;
      const quantite = (raw === '' || raw === null || raw === undefined)
        ? 0
        : (typeof raw === 'number'
          ? raw
          : parseInt(String(raw), 10));
      const temp = props.selected.produitPrix;
      temp[i].quantite = isNaN(quantite) ? 0 : quantite;
      props.setSelected(prevSelected => ({
        ...prevSelected,
        produitPrix: temp
      }));
    }
  };

  const onConfirm = () => {
    if (!props.selected) return
    const newItem = {};
    newItem["type"] = "boutique";
    if (props.selected?.idProduit) newItem["idProduit"] = props.selected.idProduit;
    if (props.selected.img) newItem["image"] = props.selected.img
    newItem["prix"] = props.selected.prix;
    newItem["name"] = props.selected.description;
    newItem["montant"] = 0;
    newItem["produitPrix"] = props.selected.produitPrix;
    newItem["taxableTps"] = props.selected.taxableTps;
    newItem["taxableTvq"] = props.selected.taxableTvq;
    newItem["inclus"] = [];
    if (newItem?.produitPrix?.length) {
      newItem.produitPrix.forEach(e => {
        const qty = Number(e.quantite) || 0;
        if (qty > 0) {
          const unitPrix = e.prix ?? newItem.prix ?? 0;
          const lineTotal = unitPrix * qty;
          newItem["montant"] += lineTotal;

          newItem["inclus"] = [...(newItem["inclus"] || []), {
            name: `${e.description}: ${qty} x ${Number(unitPrix).toFixed(2)}$`, textVal: '', value: ''
          }];
        }
      });
    }
    if (props.onAddUpdateShoppingCart)
      props.onAddUpdateShoppingCart(newItem);
    else
      dispatch(addToShoppingCart(newItem));

    props.handleClose();
  }

  return (
    <div>
      <Popup on="click" open={props.isOpen} onClose={props.handleClose} modal={true} closeOnDocumentClick={false} nested className="popup-demander-produit-prix">
        <div className="demander-produit-prix-header">
          <h3>Format</h3>
        </div>
        <div className="demander-produit-prix-body">
          {props.selected?.produitPrix.map((produit, i) => {
            const prix = produit.prix;
            if (typeof prix === 'string')
              console.log(prix)

            return (
              <div className="demander-produit-prix-row" key={produit.idProduitPrix}>
                <span style={{ flex: 1, textAlign: "start" }}>{produit.description || 'non défini'}</span>
                {(
                  <div style={{ paddingRight: "1rem" }}>
                    {`${Number(prix).toFixed(2)} $ x `}
                  </div>
                )}
                <SpinInput min={0}
                  max={produit.isAdulte ? (props.maxAdulte || 1) * 2 : 999}
                  name={produit.idProduitPrix}
                  value={produit.quantite || 0}
                  onChange={(e) => onChange(i, e)}
                />
              </div>
            );
          })}
        </div>
        <div className="demander-produit-prix-actions">
          <button onClick={onConfirm}>Ok</button>
          <button onClick={() => props.handleClose()}>Annuler</button>
        </div>
      </Popup>
    </div>
  );
};

DemanderProduitPrix.prototype = {
  trancheAges: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  onValueChange: PropTypes.func,
  selected: PropTypes.object
}

export default DemanderProduitPrix;
